const isHiddenName = (username: string): boolean => (/[.]/u).test(username);

export default isHiddenName;
